import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const cmsTextBlockEntity: Entity = {
  model: model,
  repository: repository,
}

export default cmsTextBlockEntity
